<template>
    <portal to="modals">
        <modal
            transition="fade"
            :name="name"
            :adaptive="true"
            :scrollable="true"
            height="auto"
            :width="width"
            :click-to-close="clickToClose"
            @before-close="$emit('hide')"
            @before-open="beforeOpen"
        >
            <div class="p-2xl">
                <div class="flex items-center mb-xl">
                    <slot name="title">
                        <h3
                            v-if="title"
                            class="m-0 headline-xl"
                            :class="titleClass"
                        >
                            {{ title }}
                        </h3>
                    </slot>

                    <button
                        v-if="showCloseButton"
                        class="ml-auto pl-lg"
                        @click="hide"
                    >
                        <font-awesome-icon
                            :icon="['fal', 'times']"
                            class="text-xl text-neutral-medium"
                        />
                    </button>
                </div>

                <slot />
            </div>
        </modal>
    </portal>
</template>

<script>
    export default {
        props: {
            title: {
                required: false,
                type: String,
                default: '',
            },
            name: {
                required: true,
                type: String,
            },
            showCloseButton: {
                required: false,
                type: Boolean,
                default: true,
            },
            width: {
                required: false,
                type: Number,
                default: 680,
            },
            openOnPageLoad: {
                type: Boolean,
                default: false,
            },
            clickToClose: {
                required: false,
                type: Boolean,
                default: false,
            },
            titleClass: {
                type: String,
                default: '',
            },
        },
        mounted() {
            if (this.openOnPageLoad) {
                this.$nextTick(() => {
                    this.$modal.show(this.name);
                });
            }
        },
        methods: {
            hide() {
                this.$modal.hide(this.name);
            },

            beforeOpen(event) {
                this.$emit('before-open', event);
            },
        },
    };
</script>